import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import withState from 'recompose/withState'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'

import DriftLink from './component'

const mapStateToProps = state => ({
  slug: PlaybookSelectors.slug(state),
  driftLinkOnly: PlaybookSelectors.isDriftLinkOnly(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setSlug: PlaybookActions.setSlug,
      setMetaAttribute: PlaybookActions.setMetaAttribute,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('driftLinkToggleStatus', 'setDriftLinkToggleStatus', props => props.driftLinkOnly),
  withHandlers({
    toggleDriftLinkOnly: props => () => {
      const { driftLinkToggleStatus, setDriftLinkToggleStatus, actions: { setMetaAttribute }} = props

      if (!driftLinkToggleStatus) {
        setMetaAttribute({ driftLinkOnly: true })
      } else {
        setMetaAttribute({ driftLinkOnly: false })
      }
      setDriftLinkToggleStatus(!driftLinkToggleStatus)
    },
    onSlugChange: props => event => {
      const { actions: { setSlug }} = props
      setSlug(event.target.value.slice(1))
    },
  })
)(DriftLink)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/DriftLink/index.js